import createAction from '../../../../actions/createAction'
import { createFetchFailureAction } from '../../../util/fetchFailure'

import {
  // BOOKINGS LIST ACTIONS - FETCH AND SAVE BOOKINGS
  SAVE_KEG_COLLECTION_BOOKINGS,
  FETCH_KEG_COLLECTION_BOOKINGS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_FAILURE,
  // BOOKINGS LIST VIEW SEARCH FILTER OPTIONS ACTIONS - FETCH AND SAVE SEARCH FILTER OPTIONS
  SAVE_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_FAILURE,
  // EXPORTED BOOKINGS LIST TO CSV
  SAVE_EXPORTED_KEG_COLLECTION_BOOKINGS_CSV_FILE,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_REQUEST,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_SUCCESS,
  FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_FAILURE,
  // SINGLE BOOKING ACTIONS - FETCH AND SAVE SINGLE BOOKING
  SAVE_SINGLE_KEG_COLLECTION_BOOKING,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_REQUEST,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_SUCCESS,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_FAILURE,
  // EDIT BOOKING ACTIONS - FETCH AND SAVE SINGLE EDITED BOOKING
  SAVE_EDITED_KEG_COLLECTION_BOOKING,
  EDIT_KEG_COLLECTION_BOOKING_REQUEST,
  EDIT_KEG_COLLECTION_BOOKING_SUCCESS,
  EDIT_KEG_COLLECTION_BOOKING_FAILURE,
  // CREATE SINGLE KEG COLLECTION REQUEST - PUT REQUEST TO CREATE A NEW KEG COLLECTION REQUEST
  CREATE_KEG_COLLECTION_REQUEST,
  CREATE_KEG_COLLECTION_SUCCESS,
  CREATE_KEG_COLLECTION_FAILURE,
  // EDIT SINGLE KEG COLLECTION REQUEST - PUT REQUEST TO EDIT AN EXISTING KEG COLLECTION REQUEST
  SAVE_EDITED_KEG_COLLECTION,
  EDIT_KEG_COLLECTION_REQUEST_,
  EDIT_KEG_COLLECTION_REQUEST_SUCCESS,
  EDIT_KEG_COLLECTION_REQUEST_FAILURE,
  // DELETE SINGLE KEG COLLECTION REQUEST - DELETE REQUEST TO DESTROY AN EXISTING KEG COLLECTION REQUEST
  DELETE_KEG_COLLECTION,
  DELETE_KEG_COLLECTION_REQUEST,
  DELETE_KEG_COLLECTION_SUCCESS,
  DELETE_KEG_COLLECTION_FAILURE,
  // COLLECTORS LIST ACTIONS - FETCH AND SAVE CUSTOMERS OF TYPE COLLECTOR
  SAVE_KEG_COLLECTION_BOOKING_COLLECTORS,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_FAILURE,
  // VENUE'S LIST ACTIONS - FETCH AND SAVE CUSTOMERS OF TYPE VENUE
  SAVE_KEG_COLLECTION_BOOKING_VENUES,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_FAILURE,
  // VENUE COLLECTION INFO ACTIONS - FETCH AND SAVE SELECTED VENUE COLLECTION INFO
  SAVE_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_FAILURE,
} from '../../../../actions/actionTypes'

// BOOKINGS LIST ACTIONS - FETCH AND SAVE BOOKINGS
export const saveKegCollectionBookings = bookingsList =>
  createAction(SAVE_KEG_COLLECTION_BOOKINGS, bookingsList)
export const fetchKegCollectionBookingsRequest = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKINGS_REQUEST)
export const fetchKegCollectionBookingsSuccess = (params, fetchedAt = Date.now()) =>
  createAction(FETCH_KEG_COLLECTION_BOOKINGS_SUCCESS, { params, fetchedAt })
export const fetchKegCollectionBookingsFailure = error =>
  createFetchFailureAction({
    type: FETCH_KEG_COLLECTION_BOOKINGS_FAILURE,
    error,
    target: null,
  })

// BOOKINGS LIST VIEW SEARCH FILTER OPTIONS ACTIONS - FETCH AND SAVE SEARCH FILTER OPTIONS
export const saveKegCollectionBookingsListViewSearchFilterOptions = searchFilterOptions =>
  createAction(SAVE_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS, {
    searchFilterOptions,
  })
export const fetchKegCollectionBookingsListViewSearchFilterOptionsRequest = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_REQUEST)
export const fetchKegCollectionBookingsListViewSearchFilterOptionsSuccess = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_SUCCESS)
export const fetchKegCollectionBookingsListViewSearchFilterOptionsFailure = error =>
  createFetchFailureAction({
    type: FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_FAILURE,
    error,
    target: null,
  })

// EXPORTED BOOKINGS LIST TO CSV
export const saveExportedKegCollectionBookingsCSVFile = bookingsExportList =>
  createAction(SAVE_EXPORTED_KEG_COLLECTION_BOOKINGS_CSV_FILE, bookingsExportList)
export const fetchExportKegCollectionBookingsToCSVRequest = () =>
  createAction(FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_REQUEST)
export const fetchExportKegCollectionBookingsToCSVSuccess = (params, fetchedAt = Date.now()) =>
  createAction(FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_SUCCESS, { params, fetchedAt })
export const fetchExportKegCollectionBookingsToCSVFailure = error =>
  createFetchFailureAction({
    type: FETCH_EXPORT_KEG_COLLECTION_BOOKINGS_TO_CSV_FAILURE,
    error,
    target: null,
  })

// SINGLE BOOKING ACTIONS - FETCH AND SAVE SINGLE BOOKING
export const saveSingleKegCollectionBooking = bookingDetails =>
  createAction(SAVE_SINGLE_KEG_COLLECTION_BOOKING, bookingDetails)
export const fetchSingleKegCollectionBookingRequest = () =>
  createAction(FETCH_SINGLE_KEG_COLLECTION_BOOKING_REQUEST)
export const fetchSingleKegCollectionBookingSuccess = () =>
  createAction(FETCH_SINGLE_KEG_COLLECTION_BOOKING_SUCCESS)
export const fetchSingleKegCollectionBookingFailure = error =>
  createFetchFailureAction({
    type: FETCH_SINGLE_KEG_COLLECTION_BOOKING_FAILURE,
    error,
    target: null,
  })

// EDIT BOOKING ACTIONS - FETCH AND SAVE SINGLE EDITED BOOKING
export const saveEditedKegCollectionBooking = bookingDetails =>
  createAction(SAVE_EDITED_KEG_COLLECTION_BOOKING, { bookingDetails })
export const editKegCollectionBookingRequest = () =>
  createAction(EDIT_KEG_COLLECTION_BOOKING_REQUEST)
export const editKegCollectionBookingSuccess = () =>
  createAction(EDIT_KEG_COLLECTION_BOOKING_SUCCESS)
export const editKegCollectionBookingFailure = error =>
  createFetchFailureAction({
    type: EDIT_KEG_COLLECTION_BOOKING_FAILURE,
    error,
    target: null,
  })

// CREATE SINGLE KEG COLLECTION REQUEST - PUT REQUEST TO CREATE A NEW KEG COLLECTION REQUEST
export const createKegCollectionBookingRequest = () => createAction(CREATE_KEG_COLLECTION_REQUEST)
export const createKegCollectionBookingSuccess = () => createAction(CREATE_KEG_COLLECTION_SUCCESS)
export const createKegCollectionBookingFailure = error =>
  createFetchFailureAction({
    type: CREATE_KEG_COLLECTION_FAILURE,
    error,
    target: null,
  })

// EDIT SINGLE KEG COLLECTION REQUEST - PUT REQUEST TO EDIT AN EXISTING KEG COLLECTION REQUEST
export const editKegCollectionRequest = () => createAction(EDIT_KEG_COLLECTION_REQUEST_)
export const saveEditedKegCollection = () => createAction(SAVE_EDITED_KEG_COLLECTION)
export const editKegCollectionRequestSuccess = () =>
  createAction(EDIT_KEG_COLLECTION_REQUEST_SUCCESS)
export const editKegCollectionRequestFailure = error =>
  createFetchFailureAction({
    type: EDIT_KEG_COLLECTION_REQUEST_FAILURE,
    error,
    target: null,
  })

// DELETE SINGLE KEG COLLECTION REQUEST - DELETE REQUEST TO DESTROY AN EXISTING KEG COLLECTION REQUEST
export const deleteKegCollection = id => createAction(DELETE_KEG_COLLECTION, { id })
export const deleteKegCollectionRequest = () => createAction(DELETE_KEG_COLLECTION_REQUEST)
export const deleteKegCollectionSuccess = () => createAction(DELETE_KEG_COLLECTION_SUCCESS)
export const deleteKegCollectionFailure = error =>
  createFetchFailureAction({
    type: DELETE_KEG_COLLECTION_FAILURE,
    error,
    target: null,
  })

// COLLECTORS LIST ACTIONS - FETCH AND SAVE CUSTOMERS OF TYPE COLLECTOR
export const saveKegCollectionBookingCollectors = collectorsList =>
  createAction(SAVE_KEG_COLLECTION_BOOKING_COLLECTORS, { collectorsList })
export const fetchKegCollectionBookingCollectorsRequest = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_REQUEST)
export const fetchKegCollectionBookingCollectorsSuccess = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_SUCCESS)
export const fetchKegCollectionBookingCollectorsFailure = error =>
  createFetchFailureAction({
    type: FETCH_KEG_COLLECTION_BOOKING_COLLECTORS_FAILURE,
    error,
    target: null,
  })

// VENUE'S LIST ACTIONS - FETCH AND SAVE CUSTOMERS OF TYPE VENUE
export const saveKegCollectionBookingVenues = venuesList =>
  createAction(SAVE_KEG_COLLECTION_BOOKING_VENUES, { venuesList })
export const fetchKegCollectionBookingVenuesRequest = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKING_VENUES_REQUEST)
export const fetchKegCollectionBookingVenuesSuccess = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKING_VENUES_SUCCESS)
export const fetchKegCollectionBookingVenuesFailure = error =>
  createFetchFailureAction({
    type: FETCH_KEG_COLLECTION_BOOKING_VENUES_FAILURE,
    error,
    target: null,
  })

// VENUE COLLECTION INFO ACTIONS - FETCH AND SAVE SELECTED VENUE COLLECTION INFO
export const saveKegCollectionBookingVenueCollectionInfo = venueCollectionInfo =>
  createAction(SAVE_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO, { venueCollectionInfo })
export const fetchKegCollectionBookingVenueCollectionInfoRequest = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_REQUEST)
export const fetchKegCollectionBookingVenueCollectionInfoSuccess = () =>
  createAction(FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_SUCCESS)
export const fetchKegCollectionBookingVenueCollectionInfoFailure = error =>
  createFetchFailureAction({
    type: FETCH_KEG_COLLECTION_BOOKING_VENUE_COLLECTION_INFO_FAILURE,
    error,
    target: null,
  })
